module.exports = __webpack_public_path__ + "static/media/eatme_logo.e2190307.jpg";